export const MENU_DESKTOP_OFFSET = 110;
export const MENU_MOBILE_OFFSET = 62;

export const scrollIntoViewWithOffset = (selector: string, offset: number) => {
    const element = document.querySelector(selector);
    if (element) {
        window.scrollTo({
            behavior: "smooth",
            top: element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
        });
    }
};
